import { render, staticRenderFns } from "./Revsearch.vue?vue&type=template&id=4f038a63&scoped=true&"
import script from "./Revsearch.vue?vue&type=script&lang=js&"
export * from "./Revsearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f038a63",
  null
  
)

export default component.exports